// Actions cho module navigation
export default {
	/**
	 * Đặt flag điều hướng Bảng kê trước khi chuyển sang màn hình Danh sách hóa đơn
	 * @param {Function} commit - Vuex commit function
	 * @param {string} reportType - Loại báo cáo: 'summary' (Tổng hợp) hoặc 'detail' (Chi tiết)
	 */
	setBangKeNavigation({ commit }, reportType) {
		commit('setBangKeNavigation', { reportType });
	},

	/**
	 * Xóa flag điều hướng Bảng kê (gọi sau khi đã đọc và xử lý xong — one-shot pattern)
	 * @param {Function} commit - Vuex commit function
	 */
	clearBangKeNavigation({ commit }) {
		commit('clearBangKeNavigation');
	}
};
